import React, { useEffect, useState } from "react";
import { useParams, useIntl } from "umi";
import { notification } from "tea-component";
import RegionSelector from "@/pages/dashboard/components/RegionSelector";
import { getReportDimensionInfo } from '@dbl/services/filter';
import { formatRegionOptions } from "@/pages/dashboard/components/NewFilter/util";
import {OptionPageSize} from "@/pages/datalab/components/SortableDrag/configration";

const RegionFilter = (props: any) => {
  const { filterInfo, system='datalab', innerFilterValueMapRef, setErrorInfo } = props;
  const { i: key, dataset, column, filterType, defaultValue = {
    regions: [],
    markets: ['255'],
    region_type: 'market',
  } } = filterInfo || {};
  const { formatMessage, locale } = useIntl();
  // 经分承接页gameCode
  const { gamecode }: any = useParams();

  const [options, setOptions] = useState([]);
  const [regionValue, setRegionValue] = useState({
    regions: [],
    markets: ['255'],
    region_type: 'market',
  });

  const onInit = () => {
    const params = {
      game_code: gamecode,
      table_id: dataset,
      dim_name: column,
      dim_has_query_table: false,
      page_size: OptionPageSize,
      system,
    };
    getReportDimensionInfo(params).then((res: any) => {
      setOptions(res?.country_list || []);
      setErrorInfo({});
    }).catch((err) => {
      notification.error({
        description: err?.msg,
      });
      setOptions([]);
      setErrorInfo(err);
    });
    setRegionValue(defaultValue);
    if (innerFilterValueMapRef.current) {
      innerFilterValueMapRef.current[key] = {
        value: defaultValue,
        defaultValue,
        operation: "include",
        column,
        table_id: dataset,
        column_type: filterType,
      };
    }
  };

  useEffect(() => {
    onInit();
  }, [dataset, column]);

  useEffect(() => {
    setRegionValue(innerFilterValueMapRef.current?.[key]?.value);
  }, [innerFilterValueMapRef.current?.[key]]);

  return <RegionSelector
    matchButtonWidth
    key={key}
    className={'dbl-search-items-country search-items-country js-search-items-country'}
    value={regionValue}
    onChange={(value) => {
      if (innerFilterValueMapRef.current) {
        innerFilterValueMapRef.current[key] = {
          value,
          defaultValue,
          operation: "include",
          column,
          table_id: dataset,
          column_type: filterType,
        };
      }
      setRegionValue(value);
      
    }}
    locale={locale}
    // popularList={popularList}，// 在restProps里面
    globalMessageHidden={false}
    globalMsg={formatMessage({ id: 'region_selector_global_message' })}
    regionCountry={formatRegionOptions(options)}
  // {...(value?.otherConfig || {})}
  />;
};

export default RegionFilter;